import { createActionType } from 'app/store/utils';

const type = createActionType('columnWidths');

export const SAVE_DATA_GRID_PANEL_COLUMN_WIDTH = type('SaveDatagridPanelColummnWidth');
export const SAVE_EXPLORER_DATA_GRID_COLUMN_WIDTH = type('SaveExplorerDataGridColumnWidth');
export const SAVE_METADATA_GRID_COLUMN_WIDTH = type('SaveMetadataGridColumnWidth');
export const SAVE_DATA_PROFILE_COLUMN_WIDTH = type('SaveDataProfileColumnWidth');
